const accessoriesData = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1600185365483-26d7a4cc7519?w=800",
    title: "Gym Duffle Bag",
    oldPrice: 1999,
    price: 1499,
    description: "Premium gym duffle bag with multiple compartments."
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=800",
    title: "Hydrate Bottle White",
    oldPrice: 799,
    price: 499,
    description: "Leak-proof sports bottle for workouts."
  },
  // Add remaining products...
];

export default accessoriesData;